export function CopyIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor">
      <path strokeLinecap="square" d="M1.5 1.5h10v10h-10z" />
      <path strokeLinecap="square" d="M4.5 11.5h-3v-10h10v3" />
      <path d="M12 4.5h2.5v10h-10V12" />
    </svg>
  );
}
